module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table1"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishName),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishName", $$v)
      },
      expression: "params.publishName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.usccNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccNum", $$v)
      },
      expression: "params.usccNum"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.usccType),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccType", $$v)
      },
      expression: "params.usccType"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("住所：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.residence),
      callback: function($$v) {
        _vm.$set(_vm.params, "residence", $$v)
      },
      expression: "params.residence"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.faren),
      callback: function($$v) {
        _vm.$set(_vm.params, "faren", $$v)
      },
      expression: "params.faren"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("注册资本或开办资金（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.yyzzZczb),
      callback: function($$v) {
        _vm.$set(_vm.params, "yyzzZczb", $$v)
      },
      expression: "params.yyzzZczb"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("成立日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.clDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "clDate", $$v)
      },
      expression: "params.clDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("营业日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "635px"
    },
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "type": "daterange",
      "size": "small",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.params.areaDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "areaDate", $$v)
      },
      expression: "params.areaDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("经营范围或业务范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.yyfw),
      callback: function($$v) {
        _vm.$set(_vm.params, "yyfw", $$v)
      },
      expression: "params.yyfw"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("登记日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.djDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "djDate", $$v)
      },
      expression: "params.djDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("证照编号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.usccCode),
      callback: function($$v) {
        _vm.$set(_vm.params, "usccCode", $$v)
      },
      expression: "params.usccCode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("营业执照或事业法人证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('div', {
    staticClass: "imgfram"
  }, [_c('img', {
    attrs: {
      "width": "250",
      "src": _vm.imgUrl,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  })])])])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "publishName",
      "inline-message": true
    }
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishName !== _vm.params.publishName ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishName", $$v)
      },
      expression: "historyJsonParams.publishName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.usccNum !== _vm.params.usccNum ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.usccNum),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "usccNum", $$v)
      },
      expression: "historyJsonParams.usccNum"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.usccOrgName !== _vm.params.usccOrgName ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.usccOrgName),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "usccOrgName", $$v)
      },
      expression: "historyJsonParams.usccOrgName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.usccType !== _vm.params.usccType ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.usccType),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "usccType", $$v)
      },
      expression: "historyJsonParams.usccType"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("住所：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.residence !== _vm.params.residence ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.residence),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "residence", $$v)
      },
      expression: "historyJsonParams.residence"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.faren !== _vm.params.faren ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.faren),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "faren", $$v)
      },
      expression: "historyJsonParams.faren"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("注册资本或开办资金（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.yyzzZczb !== _vm.params.yyzzZczb ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.yyzzZczb),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "yyzzZczb", $$v)
      },
      expression: "historyJsonParams.yyzzZczb"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("成立日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    class: _vm.historyJsonParams.clDate !== _vm.params.clDate ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.historyJsonParams.clDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "clDate", $$v)
      },
      expression: "historyJsonParams.clDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("营业日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "historyJsonParams.startYyDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.startYyDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "startYyDate", $$v)
      },
      expression: "historyJsonParams.startYyDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midSpan"
  }, [_vm._v("至")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "disabled": "",
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.endYyDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "endYyDate", $$v)
      },
      expression: "historyJsonParams.endYyDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("经营范围或业务范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.yyfw !== _vm.params.yyfw ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.yyfw),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "yyfw", $$v)
      },
      expression: "historyJsonParams.yyfw"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("登记日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    class: _vm.historyJsonParams.djDate !== _vm.params.djDate ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.historyJsonParams.djDate),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "djDate", $$v)
      },
      expression: "historyJsonParams.djDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("证照编号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.usccCode !== _vm.params.usccCode ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.usccCode),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "usccCode", $$v)
      },
      expression: "historyJsonParams.usccCode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("营业执照或事业法人证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('div', {
    staticClass: "imgfram"
  }, [_c('img', {
    attrs: {
      "src": _vm.historyImgUrl,
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("单位基本信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("企业性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.nature),
      callback: function($$v) {
        _vm.$set(_vm.params, "nature", $$v)
      },
      expression: "params.nature"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.CompanyNatureMap[_vm.params.nature] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.otherNature),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherNature", $$v)
      },
      expression: "params.otherNature"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否为独立法人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.isIndependentLP),
      callback: function($$v) {
        _vm.$set(_vm.params, "isIndependentLP", $$v)
      },
      expression: "params.isIndependentLP"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("注：以音像电子业务为主体业务的独立法人单位填写\"是\"，其他单位填写\"否\"")])], 1)]), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人单位类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.unitType),
      callback: function($$v) {
        _vm.$set(_vm.params, "unitType", $$v)
      },
      expression: "params.unitType"
    }
  }, _vm._l((_vm.dicDats['C019']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.independentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "independentLPSituation", $$v)
      },
      expression: "params.independentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C003']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 2) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("非独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.nonIndependentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "nonIndependentLPSituation", $$v)
      },
      expression: "params.nonIndependentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C004']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishAddr", $$v)
      },
      expression: "params.publishAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPostalcode", $$v)
      },
      expression: "params.publishPostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishLinkman", $$v)
      },
      expression: "params.publishLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishTel", $$v)
      },
      expression: "params.publishTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.publishPhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "publishPhone", $$v)
      },
      expression: "params.publishPhone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位职工总数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.workers),
      callback: function($$v) {
        _vm.$set(_vm.params, "workers", $$v)
      },
      expression: "params.workers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("\n              从事"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("业务人员数：\n            ")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.businessWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessWorkers", $$v)
      },
      expression: "params.businessWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他人员数：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.otherWorkers),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherWorkers", $$v)
      },
      expression: "params.otherWorkers"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("资产总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.totalAssets),
      callback: function($$v) {
        _vm.$set(_vm.params, "totalAssets", $$v)
      },
      expression: "params.totalAssets"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("负债总额（万元）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "inline-message": true
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "precision": 2,
      "controls": false,
      "size": "small"
    },
    model: {
      value: (_vm.params.totalLiabilities),
      callback: function($$v) {
        _vm.$set(_vm.params, "totalLiabilities", $$v)
      },
      expression: "params.totalLiabilities"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("企业性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.nature !== _vm.params.nature ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.nature),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "nature", $$v)
      },
      expression: "historyJsonParams.nature"
    }
  }, _vm._l((_vm.dicDats['C001']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.CompanyNatureMap[_vm.params.nature] == '其他') ? _c('el-input', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "若企业性质为“其他”，请输入"
    },
    model: {
      value: (_vm.params.otherNature),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherNature", $$v)
      },
      expression: "params.otherNature"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否为独立法人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.isIndependentLP !== _vm.params.isIndependentLP ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.isIndependentLP),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "isIndependentLP", $$v)
      },
      expression: "historyJsonParams.isIndependentLP"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "tip-red"
  }, [_vm._v("以音像电子业务为主体业务的独立法人单位填写“是”，其他单位填写“否”")])], 1)]), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人单位类型：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.unitType !== _vm.params.unitType ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.unitType),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "unitType", $$v)
      },
      expression: "historyJsonParams.unitType"
    }
  }, _vm._l((_vm.dicDats['C019']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 1) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.independentLPSituation !== _vm.params.independentLPSituation ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.independentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "independentLPSituation", $$v)
      },
      expression: "historyJsonParams.independentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C003']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.layDasion == 2) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("非独立法人隶属关系：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.nonIndependentLPSituation !== _vm.params.nonIndependentLPSituation ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.nonIndependentLPSituation),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "nonIndependentLPSituation", $$v)
      },
      expression: "historyJsonParams.nonIndependentLPSituation"
    }
  }, _vm._l((_vm.dicDats['C004']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishAddr !== _vm.params.publishAddr ? 'highlight' : '',
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishAddr),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishAddr", $$v)
      },
      expression: "historyJsonParams.publishAddr"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishPostalcode !== _vm.params.publishPostalcode ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishPostalcode", $$v)
      },
      expression: "historyJsonParams.publishPostalcode"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishLinkman !== _vm.params.publishLinkman ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishLinkman),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishLinkman", $$v)
      },
      expression: "historyJsonParams.publishLinkman"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishTel !== _vm.params.publishTel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishTel),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishTel", $$v)
      },
      expression: "historyJsonParams.publishTel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.publishPhone !== _vm.params.publishPhone ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.publishPhone),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "publishPhone", $$v)
      },
      expression: "historyJsonParams.publishPhone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "numLine",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("单位职工总数：")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.workers !== _vm.params.workers ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.workers),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "workers", $$v)
      },
      expression: "historyJsonParams.workers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("\n                  从事"), (_vm.pressType == 1) ? _c('span', [_vm._v("音像")]) : (_vm.pressType == 2) ? _c('span', [_vm._v("电子")]) : _vm._e(), _vm._v("业务人员数：\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.businessWorkers !== _vm.params.businessWorkers ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.businessWorkers),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "businessWorkers", $$v)
      },
      expression: "historyJsonParams.businessWorkers"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("其他人员数：")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.otherWorkers !== _vm.params.otherWorkers ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "disabled": "",
      "min": 0,
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.otherWorkers),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "otherWorkers", $$v)
      },
      expression: "historyJsonParams.otherWorkers"
    }
  })], 1)])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "numLine",
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("资产总额（万元）：")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.totalAssets !== _vm.params.totalAssets ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.totalAssets),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "totalAssets", $$v)
      },
      expression: "historyJsonParams.totalAssets"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "numInp"
  }, [_c('div', {
    staticClass: "inpName"
  }, [_vm._v("负债总额（万元）：")]), _vm._v(" "), _c('div', {
    staticClass: "inpText"
  }, [_c('el-input-number', {
    class: _vm.historyJsonParams.totalLiabilities !== _vm.params.totalLiabilities ? 'highlight' : '',
    attrs: {
      "controls-position": "right",
      "min": 0,
      "precision": 2,
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.totalLiabilities),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "totalLiabilities", $$v)
      },
      expression: "historyJsonParams.totalLiabilities"
    }
  })], 1)])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp spMake"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "remark",
      "inline-message": true
    }
  }, [_c('el-input', {
    class: _vm.historyJsonParams.remark !== _vm.params.remark ? 'highlight' : '',
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.remark),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "remark", $$v)
      },
      expression: "historyJsonParams.remark"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea editBox"
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.params.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imgUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-1：基本情况表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("工商营业执照或事业法人证书信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66919765"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table1.vue
// module id = 1757
// module chunks = 1